import { FormEventHandler } from 'react';
import { SEPARATOR } from 'utils/constants/betslip';

export const getIsPositiveNumber = (value: string): boolean =>
  /^[+]?((?!00\d*$)[0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/.test(value);

export const getValidPositiveNumber = (
  value?: string,
  separator?: boolean
): string | undefined => {
  if (!value) {
    return;
  }

  if (value.includes(',') && !separator) {
    value = value.replace(',', '.');
  }

  value = value.replace(/[^\d.]/g, '');
  let formattedValue = String(value?.replace(',', '.'));

  if (formattedValue.includes('.')) {
    const indexOfFirst = formattedValue.indexOf('.');
    const indexOfSecond = formattedValue.indexOf('.', indexOfFirst + 1);

    if (indexOfSecond !== -1) {
      formattedValue = formattedValue.substring(0, indexOfSecond);
    }
  }

  let updatedValue = null;

  if (
    formattedValue.length === 2 &&
    +formattedValue[0] === 0 &&
    formattedValue[1] !== '.'
  ) {
    updatedValue = `0.${formattedValue[1]}`;
  }

  if (getIsPositiveNumber(formattedValue) || !value || updatedValue) {
    return updatedValue || formattedValue;
  }
};

export const getValidDecimalInput: FormEventHandler<HTMLInputElement> = (
  event
): void => {
  const target = event.target as HTMLInputElement;
  const regex = /[^0-9.]/g;

  if (`${target.value || ''}`.charAt(0) === '.') {
    target.value = `0${target.value}`;
  } else {
    if (target.value.split('.').length > 2) {
      target.value = target.value.slice(0, target.value.lastIndexOf('.'));
    } else {
      target.value = target.value.replace(regex, '');
    }
  }
};

export const thousandSeparator = (value: string | number): string | number => {
  const valString = value?.toString() || '';

  return SEPARATOR && value
    ? valString.indexOf('.') <= valString.indexOf(',')
      ? valString.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : valString
          .split('.')[0]
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          .concat('.', valString.split('.')[1].replace(',', ''))
    : value;
};

export const removeComma = (value: string): string => {
  if (value) {
    return value.replace(',', '');
  }

  return value;
};

type TCheckInitialLimitValues = {
  [key: string]: string | number | undefined;
};

export const checkInitialLimitValues = (
  formData: TCheckInitialLimitValues,
  initialData: TCheckInitialLimitValues
): boolean => {
  let isFieldTouched = false;

  Object.entries(formData).forEach(([key, value]): void => {
    const initialValue = initialData[key as keyof typeof initialData];

    if (Number(initialValue) !== Number(value)) {
      isFieldTouched = true;
    }
  });

  return isFieldTouched;
};

export const getValidDecimalInputNoDot: FormEventHandler<HTMLInputElement> = (
  event
): void => {
  const target = event.target as HTMLInputElement;
  const regex = /[^0-9]/g;
  target.value = target.value.replace(regex, '');
};
